<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="parts" :rules="rules" ref="parts" :key="isNew">
        <input-form-item label="项目名称" prop="name"></input-form-item>
        <remote-form-item label="项目分类" prop="typeCode" using-code class-name="PARTS_TYPE"></remote-form-item>
        <remote-form-item label="品牌" prop="brandIds" class-name="Brand"></remote-form-item>
        <status-form-item label="状态"></status-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import InputFormItem from '@/components/form/InputFormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'

  export default {
    name: 'EditPartsDialog',
    components: {
      RemoteFormItem,
      TextareaFormItem,
      StatusFormItem,
      InputFormItem
    },
    props: {
      parts: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入施工项名称',
              trigger: 'blur'
            }
          ],
          typeCode: [
            {
              required: true,
              message: '请选择施工项分类',
              trigger: 'change'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        if (!this.readOnly) {
          this.$refs.parts.resetFields()
        }
      },
      add () {
        this.$refs.parts.validate(valid => {
          if (!valid) return

          this.$store.dispatch('parts/add', this.$_.cloneDeep(this.parts)).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.parts.validate(valid => {
          if (!valid) return

          this.$store.dispatch('parts/updateOne', this.$_.cloneDeep(this.parts)).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.parts.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增施工项'
        return this.readOnly ? '查看施工项' : '编辑施工项'
      }
    }
  }
</script>
